import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ControlliService } from '../../../../services/controlli.service';
import { LimiteLegge } from '../../../../models/controlli.model';

/**
 * Popup "Parametri Analitici ammessi" (Controlli/Prelievi): carica da se' l'elenco
 * dei parametri validi (limiti_legge, antiparassitari inclusi) da mostrare all'utente
 * durante la compilazione del file Excel.
 */
@Component({
  selector: 'ebw-monorepo-controlli-codici-prelievi-dialog',
  templateUrl: './controlli-codici-prelievi-dialog.component.html',
  styleUrls: ['./controlli-codici-prelievi-dialog.component.scss']
})
export class ControlliCodiciPrelieviDialogComponent implements OnInit {
  parametri: LimiteLegge[] = [];
  loading = true;

  readonly columns = ['codice', 'tipologia', 'obbligatorio', 'range_consentito', 'unita_misura'];

  constructor(
    private _controlliService: ControlliService,
    private _dialogRef: MatDialogRef<ControlliCodiciPrelieviDialogComponent>
  ) {}

  ngOnInit(): void {
    this._controlliService.getParametriAnalitici().subscribe({
      next: (response) => {
        this.parametri = [...response.parametri].sort((a, b) => a.codice.localeCompare(b.codice));
        this.loading = false;
      },
      error: () => (this.loading = false)
    });
  }

  close(): void {
    this._dialogRef.close();
  }
}
